import React from "react";

const pressReleases = [
  {
    id: 1,
    date: "June 8, 2025",
    location: "Cambridge, Massachusetts - (International Research Olympiad)",
    title:
      "Twenty-One High Schoolers Compete at the 2025 International Research Olympiad Finals",
    content: [
      "June 8th, 2025, Cambridge, MA — The International Research Olympiad featured over 3,000 participants from 80+ countries. After several rounds of examinations, twenty-one finalists competed at the Finals event from June 6 to June 8 in Cambridge, MA.",
      "The International Research Olympiad (IRO) is dedicated to cultivating analytical and critical thinking capabilities among aspiring student researchers--fundamental skills for scientific discovery. The IRO champions a philosophy of rigorous inquiry and intellectual development, emphasizing understanding over memorization. Students are challenged to apply knowledge practically and think systematically, fostering a profound appreciation for scientific investigation and innovation.",
      "Contestants may be awarded gold, silver and bronze medals at the finals event.",
      "The finalists represent the top 0.7% of competitors, having scored highest at the IRO Semifinals and Opens Exams. By emphasizing research and critical thinking at such a formative stage, the IRO is crafting the next generation of scientists, innovators, and thought leaders. These students will go on to tackle global challenges, making significant contributions to science and society.",
    ],
    awards: [
      {
        type: "Gold Medal",
        recipients: ["Kelly Lock from Fremont, California, won 1st Place."],
      },
      {
        type: "Silver Medal",
        recipients: [
          "Ameya Kharade from Nashua, New Hampshire, won 2nd Place and a Silver Medal.",
          "Colin Yuanjie Ding from Closter, New Jersey, won 3rd Place and a Silver Medal.",
        ],
      },
      {
        type: "Bronze Medal",
        recipients: [
          "Cyrus Ghane from San Jose, California, won 4th Place and a Bronze Medal.",
          "Yanrui Liu from North York, Ontario, Canada, won 5th Place and a Bronze Medal.",
          "Jia Chen Qu from Zhejiang Province, China, won 6th Place and a Bronze Medal.",
        ],
      },
    ],
    specialAwardsIntro:
      "IRO Special Awards include the Public Science Communication Award, the Class Speaker Award, and the Team Award. These recognitions complement the primary competition by highlighting additional dimensions of scientific excellence and leadership among tomorrow's researchers.",
    specialAwards: [
      {
        name: "Public Science Communication Award",
        description:
          "The recipient of this award was chosen by IRO's community of over 30,000 students cumulatively. Finalists created a five minute video explaining a particularly interesting research topic to the general public.",
        winner:
          "The winner was Devesh Aggarwal from Bellevue, Washington, whose video demonstrated exceptional ability to translate complex scientific concepts into accessible content, combining scientific rigor with engaging communication techniques.",
      },
      {
        name: "Class Speaker Award",
        description:
          "Selected by their fellow finalists, the Class Speaker delivered remarks at the Finals ceremony, representing the collective voice and experience of this year's exceptional cohort.",
        winner:
          "The honor was given to Sammit Prem Chidambaram from Dunlap, Illinois, who captured the spirit of scientific discovery and collaborative learning that defines the IRO community.",
      },
      {
        name: "Team Award",
        description:
          "The team award was given to the team that best demonstrated cohesiveness, collaboration, and a dedication to the scientific research pursuit.",
        winner:
          "The winners were Research Rovers: Kelly Lock from Fremont, California; Amber Chow from Markham, Ontario, Canada; Elie Ciril Jr. from Plantation, Florida; Cyrus Ghane from San Jose, California.",
      },
    ],
    quotes: [
      {
        text: "The IRO continues to distinguish itself through its emphasis on analytical reasoning and scientific inquiry. This year's participants demonstrated exceptional intellectual curiosity and research acumen--qualities that will serve them well as they pursue careers in science and innovation.",
        author: "Rishab Kumar Jain, President of the IRO",
      },
      {
        text: "Witnessing the caliber of thinking and collaboration among these young researchers has been inspiring. These students approached complex problems with sophistication and creativity, developing insights that could genuinely influence future scientific discourse. Their results reflect not just knowledge, but genuine scientific thinking.",
        author: "Yashvir Sabharwal, Student Board Member",
      },
    ],
    closing:
      "The 2025 IRO Finals brought together exceptional talent from across the globe, highlighting the international scope of scientific curiosity among young researchers. Through its focus on critical analysis and practical problem-solving, the IRO continues developing tomorrow's scientific leaders who will address humanity's greatest challenges.",
  },
  {
    id: 2,
    date: "April 21, 2025",
    location: "Cambridge, Massachusetts - (Samyak Science Society)",
    title:
      "Top High School Students Advance in International Research Olympiad as Semifinals Conclude",
    content: [
      "April 21, 2025, Cambridge, MA — The Samyak Science Society announces the successful completion of the Semifinals Exam of the 2025 International Research Olympiad (IRO). This critical phase has identified the top fifteen students who will advance to the Finals at Harvard University in May.",
      "The Semifinals introduced a comprehensive assessment format featuring multiple choice questions, free response questions, and a challenging oral component. Participants tackled four papers, each containing six weighted MCQs and two FRQs followed by a 5-minute oral presentation section worth 25 points. Questions spanned disciplines including Computer Science, Engineering, Medicine, Neuroscience, Physics, Mathematics, Artificial Intelligence, and Biology.",
    ],
    quotes: [
      {
        text: "The wide range of perspectives showcased in the oral presentations were truly remarkable. Students demonstrated exceptional ability to analyze research papers critically and communicate complex ideas with clarity and confidence -- essential skills for future scientific leaders, and the exact skills the IRO aims to develop in its participants.",
        author: "Rishab Jain, President of the IRO",
      },
    ],
    additionalContent: [
      "The Free Response Questions revealed impressive scientific depth and critical thinking abilities among participants. Students tackled research prompts with sophisticated analysis, demonstrating the core analytical skills the IRO aims to cultivate. Their responses showed remarkable engagement with scientific literature, offering creative interpretations and insightful critiques of methodologies and findings.",
      "Selecting the top fifteen finalists proved exceptionally challenging for the grading panel, comprised of members from the student board and board of advisors. The exceptional quality of submissions reflected the growing global interest in research-focused competition, with participants demonstrating remarkable proficiency across varied scientific disciplines.",
      "The IRO Finals will take place at Harvard University in May 2025, where these outstanding young researchers will compete for gold, silver, and bronze medals. The Finals will further challenge students to demonstrate their research capabilities through a series of advanced assessments designed to identify tomorrow's scientific innovators.",
      "The Samyak Science Society congratulates all Semifinalists on their achievements and looks forward to witnessing the culmination of this year's competition at the Finals event.",
    ],
    callToAction:
      "Students interested in participating in the IRO's Open Exams can register through the official IRO website. Additional details about the exam format and registration process will be made available soon.",
  },
  {
    id: 3,
    date: "February 3, 2025",
    location: "Cambridge, Massachusetts",
    title:
      "International Research Olympiad Opens Registration for 2025 Competition",
    content: [
      "The Samyak Science Society is excited to announce the launch of the Open Exams for the 2025 International Research Olympiad (IRO). The IRO's Open Exams are designed to provide high school students from around the world an opportunity to demonstrate their knowledge and passion for scientific research. These exams will be the first step toward entering the competition, where participants can showcase their academic skills and earn a chance to advance to the next round.",
      "The IRO Open Exams are open to all students aged 13 to 18, and are designed to assess critical thinking, scientific understanding, and creativity. Students will have the opportunity to participate in multiple-choice questions across a variety of scientific disciplines. The exams are intended to challenge students and inspire them to go deeper into the world of scientific research.",
    ],
    quotes: [
      {
        text: "We are thrilled to open the doors for students to begin their journey in the International Research Olympiad. The Open Exams serve as a gateway for young minds eager to pursue scientific exploration. It's an opportunity for them to engage with a global community of like-minded individuals and challenge themselves on a broader stage.",
        author: "Rishab Jain, President of the IRO",
      },
    ],
    additionalContent: [
      "The Open Exams will take place online in March 2025, with students participating from all corners of the world. After this initial round, the top performers will progress to the semifinalist stage.",
      "Students interested in participating in the IRO's Open Exams can register through the official IRO website. Additional details about the exam format and registration process will be made available soon.",
      "The Samyak Science Society encourages all passionate high school students to participate in the IRO and to challenge themselves to explore the exciting world of scientific research.",
    ],
  },
  {
    id: 4,
    date: "June 3, 2024",
    location: "Cambridge, Massachusetts - (Samyak Science Society)",
    title:
      "Fifteen High Schoolers Compete at the 2024 International Research Olympiad Finals",
    content: [
      "June 2nd, 2024, Cambridge, MA — The International Research Olympiad featured over 1,000 participants from 45 countries. After several rounds of examinations, fifteen finalists competed at the Finals event from May 31 to June 2 in Cambridge, MA.",
      "The International Research Olympiad (IRO) is dedicated to honing analytical and critical thinking skills for student researchers—essential in scientific exploration. The IRO fosters a culture of rigorous research and skill-building, not just memorizing formulae. The practical applications of knowledge and big-picture thinking are tested, allowing students to walk away with a deeper passion for scientific inquiry and engineering.",
      "Contestants may be awarded gold, silver and bronze medals at the finals event.",
      "The finalists represent the top 1% of competitors, having scored highest at the IRO Semifinals and Opens Exams. By emphasizing research and critical thinking at such a formative stage, the IRO is crafting the next generation of scientists, innovators, and thought leaders. These students will go on to tackle global challenges, making significant contributions to science and society.",
    ],
    awards: [
      {
        type: "Gold Medal",
        recipients: [
          "Jaansi Patel from Edison, New Jersey, of Phillips Exeter Academy, won 1st Place.",
        ],
      },
      {
        type: "Silver Medal",
        recipients: [
          "Edward Kang from Upper Saddle River, New Jersey, of Bergen County Academies won 2nd Place and a Silver Medal.",
          "Antara Chhabra from Bengaluru, India, of Shri Ram Global School won 3rd Place and a Silver Medal.",
        ],
      },
      {
        type: "Bronze Medal",
        recipients: [
          "Vishnu Mangipudi from Seattle, Washington, of Lakeside School won 4th Place.",
          "Ruuhan Anand from Singapore, of Raffles Institution, won 5th Place.",
          "Ethan Sullivan from Miami, Florida, of Ransom Everglades School won 6th Place.",
        ],
      },
    ],
    specialAwardsIntro:
      "IRO Special Awards include the Public Science Communication Award and the Team Award. While not deciding factors of the grand awards, they help further IRO's dedication towards fostering scientific research in the changemakers of tomorrow.",
    specialAwards: [
      {
        name: "Public Science Communication Award",
        description:
          "The recipient of this award was chosen by IRO's community of over 25,000 students cumulatively. Finalists created a five minute video explaining a particularly interesting research topic to the general public.",
        winner:
          "The winner was Edward Kang from Upper Saddle River, New Jersey, whose video appealed to the public the most, displaying creativity, a well-balanced and eloquent presentation, and a passion for scientific research.",
      },
      {
        name: "Team Award",
        description:
          "The team award was given to the team that best demonstrated cohesiveness, collaboration, and a dedication to the scientific research pursuit.",
        winner:
          "The winners were: Ethan Sullivan from Miami, Florida, of Ransom Everglades School; Antara Chhabra from Bengaluru, India, of Shri Ram Global School; Amit Bhatt from Iowa City, Iowa, of Iowa City West High School.",
      },
    ],
    quotes: [
      {
        text: "What sets the IRO apart is our commitment to critical thinking, which is essential for scientific research. We've seen a high number of contestants who possess extraordinary potential—and who are serious and motivated about their research-based, real-world interests.",
        author:
          "Rishab Kumar Jain, President and Chair of the Student Board of Advisors to the International Research Olympiad",
      },
      {
        text: "The IRO Finals took place in a time like no other, and students showed a level of adaptability and resilience that was remarkable. Each student tackled a crucial issue, and presented their solutions so that they would matter to the world today.",
        author: "Yashvir Sabharwal, Executive & Education Coordinator",
      },
    ],
    closing:
      "The 2024 IRO Finals showcased some of the most promising young minds in the world. With its dedication to critical thinking and real-world application of knowledge, the IRO is shaping the next generation of innovative leaders who will tackle global challenges and make a lasting impact on society.",
  },
  {
    id: 5,
    date: "January 3, 2024",
    location: "Cambridge, Massachusetts - (Samyak Science Society)",
    title:
      "Samyak Science Society Announces Creation of International Research Olympiad",
    content: [
      "The Samyak Science Society is pleased to announce the creation of the International Research Olympiad: the world's first olympiad-style competition for high school students dedicated solely to scientific research. The International Research Olympiad (IRO) aims to inspire and challenge students to pursue scientific research in diverse fields and foster a culture of learning. The competition is open to all thirteen through eighteen-year-olds around the globe and will encourage students to improve critical thinking, scientific reading, and science communication skills.",
      "The Samyak Science Society, a non-profit organization established in 2019, aims to promote science and scientific thinking among young minds. In line with this mission, the IRO will allow students to showcase their skills and creativity in diverse scientific areas. The competition will consist of four rounds, including a written test, a research proposal submission, a research project presentation, and more unique events. There will be two rounds of open exams, a semifinalist round, and a final round, after which medalists will be determined. Further details of the competition format and rules will be announced on the IRO website.",
      "The IRO is engaging in key partnerships with organizations to provide research mentorship opportunities for students and encourage students to explore their original work after the competition.",
      "The IRO's organizers hope the competition will foster a sense of global community and collaboration among students interested in scientific research.",
    ],
    quotes: [
      {
        text: "We believe that the International Research Olympiad will not only encourage and recognize exceptional research talent but also inspire students from all backgrounds to develop their scientific curiosity and explore the world around them.",
        author: "Rishab Jain, President of the IRO",
      },
    ],
    additionalContent: [
      "The first open exam round for the IRO is scheduled to take place in March 2024, with the top performers advancing to the semifinalist round in March 2024. The final round of the competition will be held in late March or April 2024, culminating in the announcement of medalists and special award recipients.",
      "The Samyak Science Society invites all high school students interested in science and research to participate in the International Research Olympiad and join them in their mission to foster a love for scientific thinking and exploration.",
    ],
  },
];

const getAwardBadgeStyle = (type) => {
  const styles = {
    "Gold Medal": {
      bg: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
      color: "#7c5800",
    },
    "Silver Medal": {
      bg: "linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)",
      color: "#4a4a4a",
    },
    "Bronze Medal": {
      bg: "linear-gradient(135deg, #CD7F32 0%, #B87333 100%)",
      color: "#5c3a1d",
    },
  };
  return styles[type] || { bg: "#004d99", color: "#fff" };
};

function PressReleases() {
  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1
              style={{
                fontSize: "clamp(2rem, 4vw, 2.5rem)",
                fontWeight: "700",
                color: "#1a1a2e",
                marginBottom: "16px",
                letterSpacing: "-0.02em",
              }}
            >
              Press Releases
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#555",
                lineHeight: "1.7",
              }}
            >
              Official announcements and news from the International Research
              Olympiad.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          {pressReleases.map((release) => (
            <article
              key={release.id}
              style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "40px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e8eef3",
              }}
            >
              {/* Header */}
              <div style={{ marginBottom: "24px" }}>
                <span
                  style={{
                    display: "inline-block",
                    padding: "6px 14px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(0, 77, 153, 0.08)",
                    color: "#004d99",
                    fontSize: "0.85rem",
                    fontWeight: "600",
                    marginBottom: "16px",
                  }}
                >
                  {release.date}
                </span>
                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#666",
                    marginBottom: "12px",
                  }}
                >
                  {release.location}
                </p>
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    lineHeight: "1.4",
                  }}
                >
                  {release.title}
                </h2>
              </div>

              {/* Content */}
              <div style={{ marginBottom: "24px" }}>
                {release.content.map((paragraph, idx) => (
                  <p
                    key={idx}
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.8",
                      marginBottom: "16px",
                    }}
                  >
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Awards */}
              {release.awards && (
                <div style={{ marginBottom: "24px" }}>
                  {release.awards.map((award, idx) => {
                    const badgeStyle = getAwardBadgeStyle(award.type);
                    return (
                      <div key={idx} style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "6px 16px",
                            borderRadius: "20px",
                            background: badgeStyle.bg,
                            color: badgeStyle.color,
                            fontSize: "0.85rem",
                            fontWeight: "600",
                            marginBottom: "8px",
                          }}
                        >
                          {award.type}
                        </span>
                        {award.recipients.map((recipient, rIdx) => (
                          <p
                            key={rIdx}
                            style={{
                              fontSize: "0.95rem",
                              color: "#555",
                              lineHeight: "1.6",
                              margin: "8px 0 0 0",
                            }}
                          >
                            {recipient}
                          </p>
                        ))}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Special Awards */}
              {release.specialAwards && (
                <div
                  style={{
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    padding: "24px",
                    marginBottom: "24px",
                  }}
                >
                  {release.specialAwardsIntro && (
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                        lineHeight: "1.8",
                        marginBottom: "20px",
                      }}
                    >
                      {release.specialAwardsIntro}
                    </p>
                  )}
                  {release.specialAwards.map((award, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom:
                          idx < release.specialAwards.length - 1 ? "20px" : 0,
                      }}
                    >
                      <p
                        style={{
                          fontSize: "0.95rem",
                          fontWeight: "600",
                          color: "#004d99",
                          marginBottom: "6px",
                        }}
                      >
                        {award.name}
                      </p>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#666",
                          marginBottom: "6px",
                        }}
                      >
                        {award.description}
                      </p>
                      <p style={{ fontSize: "0.95rem", color: "#555" }}>
                        {award.winner}
                      </p>
                    </div>
                  ))}
                </div>
              )}

              {/* Quotes */}
              {release.quotes &&
                release.quotes.map((quote, idx) => (
                  <div
                    key={idx}
                    style={{
                      borderLeft: "4px solid #004d99",
                      paddingLeft: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                        lineHeight: "1.8",
                        fontStyle: "italic",
                        marginBottom: "8px",
                      }}
                    >
                      "{quote.text}"
                    </p>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        color: "#1a1a2e",
                        fontWeight: "600",
                      }}
                    >
                      — {quote.author}
                    </p>
                  </div>
                ))}

              {/* Call to Action */}
              {release.callToAction && (
                <p
                  style={{
                    fontSize: "0.95rem",
                    color: "#555",
                    lineHeight: "1.8",
                    marginBottom: "20px",
                  }}
                >
                  {release.callToAction}
                </p>
              )}

              {/* Additional Content */}
              {release.additionalContent &&
                release.additionalContent.map((paragraph, idx) => (
                  <p
                    key={idx}
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.8",
                      marginBottom: "16px",
                    }}
                  >
                    {paragraph}
                  </p>
                ))}

              {/* Closing */}
              {release.closing && (
                <p
                  style={{
                    fontSize: "0.95rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  {release.closing}
                </p>
              )}
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PressReleases;
